import { Skeleton } from "@/components/ui/skeleton";

/** Skeleton karty kierunku (siatka "Popularne kierunki"). */
export function RouteCardSkeleton() {
  return (
    <div className="glass flex items-center justify-between rounded-lg p-5">
      <div className="space-y-2">
        <Skeleton className="h-3 w-20" />
        <Skeleton className="h-6 w-28" />
      </div>
      <div className="space-y-2 text-right">
        <Skeleton className="ml-auto h-3 w-12" />
        <Skeleton className="ml-auto h-5 w-16" />
      </div>
    </div>
  );
}

/** Siatka skeletonów odpowiadająca układowi popularnych kierunków. */
export function PopularRoutesSkeleton({ count = 12 }: { count?: number }) {
  return (
    <div
      className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
      aria-busy="true"
      aria-label="Ładowanie popularnych kierunków"
    >
      {Array.from({ length: count }).map((_, i) => (
        <RouteCardSkeleton key={i} />
      ))}
    </div>
  );
}

/** Skeleton karty wyniku lotu (dopasowany do FlightCard). */
export function FlightCardSkeleton() {
  return (
    <div className="glass rounded-lg p-5">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <Skeleton className="h-10 w-10 rounded-full" />
          <div className="space-y-2">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-3 w-24" />
          </div>
        </div>
        <div className="hidden flex-1 items-center gap-3 md:flex">
          <Skeleton className="h-3 w-12" />
          <Skeleton className="h-px flex-1" />
          <Skeleton className="h-3 w-12" />
        </div>
        <div className="space-y-2 text-right">
          <Skeleton className="ml-auto h-6 w-20" />
          <Skeleton className="ml-auto h-3 w-16" />
        </div>
      </div>
    </div>
  );
}

/** Lista skeletonów wyników lotów. */
export function FlightResultsSkeleton({ count = 5 }: { count?: number }) {
  return (
    <div className="space-y-4" aria-busy="true" aria-label="Ładowanie wyników lotów">
      {Array.from({ length: count }).map((_, i) => (
        <FlightCardSkeleton key={i} />
      ))}
    </div>
  );
}
